export function setUtcHours(oldDate: Date, hours: string, min: string) {
    const newDate = new Date(oldDate)
    newDate.setUTCHours(parseInt(hours, 10), parseInt(min, 10), 0)
    return newDate
}
